<template>
  <p class="w-full my-auto text-center text-3xl text-gray-400">
    Loading...
  </p>
</template>
